import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AdminAuthProvider } from "@/context/AdminAuth";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Book from "@/pages/Book";
import Announcements from "@/pages/Announcements";
import PostDetail from "@/pages/PostDetail";
import Policies from "@/pages/Policies";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";
import PaymentResult from "@/pages/PaymentResult";

function App() {
    return (
        <div className="App">
            <Toaster position="top-right" richColors />
            <AdminAuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/book" element={<Book />} />
                        <Route path="/announcements" element={<Announcements />} />
                        <Route path="/post/:id" element={<PostDetail />} />
                        <Route path="/policies" element={<Policies />} />
                        <Route path="/admin" element={<AdminLogin />} />
                        <Route path="/admin/callback" element={<AuthCallback />} />
                        <Route path="/admin/dashboard" element={<AdminDashboard />} />
                        <Route path="/payment/success" element={<PaymentResult status="success" />} />
                        <Route path="/payment/cancel" element={<PaymentResult status="cancel" />} />
                    </Routes>
                </BrowserRouter>
            </AdminAuthProvider>
        </div>
    );
}

export default App;
